import { AlgChannelService } from "./channel.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class FeedFacebookService extends AlgChannelService {


  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE
    this.endpointPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE
    this.httpClient = httpClient;
  }

  public sendNewPost(data: FormData, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + 'facebook/feed/send-post'
    return this.httpClient.post(
      url,
      data,
      this.getHeader(apiVisa)
    );
  }

  public editPost(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + 'facebook/feed/update';
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    )
  }

  public deletePost(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + 'facebook/feed/delete'
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    )

  }


  getHeader(apiVisa) {
    let headers = new HttpHeaders({
        'tenant-code': apiVisa.tenantCode
    })
    return { headers: headers };
}
}